export class ConfiguracionCompensacion {
    configuracionCompensacionPK: ConfiguracionCompensacionPK;
    estado: string;
    horarioCompensacion: string;
    horasAjuste: number;
    horasCompensacion: number;
    observacionesFuncionario: string;
    observacionesJefeArea: string;
    porcentajeCompensacion: number;
}

export class ConfiguracionCompensacionPK {
    numeroIdFuncionario: string;
    tipoIdFuncionario: string;
    turnoIdTurno: number;
}